import styled from "styled-components"
import { TitleProps } from "./interfaces"
import { colors } from "lib/colors"

export const StyledAmount = styled.p<TitleProps>`
  display: flex;
  align-items: center;
  /* justify-content: flex-start; */
  justify-content: ${({ justify }) => justify || "center"};
  color: ${({ color }) => color || "#38433d;"};
  font-size: ${({ size }) => size || "12px"};
  font-weight: ${({ fontWeight }) => fontWeight || "400"};
  margin-top: ${({ marginTop }) => marginTop || "0"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "0"};
  margin-right: ${({ marginRight }) => marginRight || "unset"};
  font-style: normal;
  line-height: ${({ lineHeight }) => lineHeight || "normal"};
  letter-spacing: normal;
  text-transform: ${({ textTransform }) => textTransform || "none"};
  text-align: ${({ align }) => align || "inherit"};
  span {
    color: #c7c7c7;
  }
  font-size: 14px;
`

export const WinText = styled.div<TitleProps>`
  transform: ${({ betReply }) =>
    betReply ? "translateX(0)" : " translateX(-100%)"};
  opacity: ${({ betReply }) => (betReply ? 1 : 0)};
  animation: ${({ showResult, betReply, dealOut }) =>
    betReply
      ? ""
      : showResult && !dealOut
      ? `fadein 0.7s forwards`
      : "fadeout 0.7s  forwards"};

  .win {
    margin-right: 5px;
    color: ${colors.quaternary};
  }
  @keyframes fadein {
    0% {
      transform: translateX(-100%);
      animation-timing-function: cubic-bezier(0.08, 0, 0, 1);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes fadeout {
    0% {
      transform: translateX(0);
      animation-timing-function: cubic-bezier(0.08, 0, 0, 1);
      opacity: 1;
    }
    100% {
      transform: translateX(150%);
      opacity: 0;
    }
  }
`
